module.exports = __webpack_public_path__ + "media/images/gift-thanks-title-onigiri@3x-7f5ff93290d9c307177c9b43193d4c62.png";